// removed by extract-text-webpack-plugin
module.exports = {"root":"_3alVTYJJOGWPrqDlhdzoTe","title":"_1OGV0vwSVRLKVIsZRZLsXm","content":"_2UiKVn_PbJA7N7Cy3G5tNa","bigTitle":"_2RZVv8hdK9pjHyRpq16bHO","bigContent":"_2zhuAWdhMzSzupRb3BYkUg","const":"_1DVhocCHMuF7jQt2Bfquda"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LabeledValue/style.css
// module id = 1074
// module chunks = 0